import React, { Component } from 'react';
import { Table, Input, Button } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import { connect } from 'react-redux';

class AthKeycardAthlete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            placeholder: [],
            sportFormItem: "default",
            startDateFormItem: "",
            endDateFormItem: "",
            startTimeFormItem: "",
            endTimeFormItem: "",
            aFormItem: false,
            bFormItem: false,
            cFormItem: false,
            dFormItem: false,
            eFormItem: false,
            fFormItem: false,
            sportData: [],
            addSuccess: false
        }
        this.getSportData();
    }

    async getSportData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetSportKeycards', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            sportData: data
        })
    }

    componentDidMount() {

    }

    async updateSport(field, pk, value) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: pk,
            field: field,
            newvalue: value.toString() 
        }
        const response = await fetch('UpdateSportKeycard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            sportData: data
        })
    }

    async deleteSport(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: pk
        }
        const response = await fetch('DeleteSportKeycard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            sportData: data
        })
    }

    async addSport(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            sport: this.state.sportFormItem,
            startdate: this.state.startDateFormItem,
            enddate: this.state.endDateFormItem,
            starttime: this.state.startTimeFormItem,
            endtime: this.state.endTimeFormItem,
            l1: this.state.aFormItem,
            l2: this.state.bFormItem,
            l3: this.state.cFormItem,
            l4: this.state.dFormItem,
            gym: this.state.eFormItem,
            volpe: this.state.fFormItem
            }
        const response = await fetch('AddSportKeycard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        this.setState({
            sportData: data,
            sportFormItem: "default",
            startDateFormItem: "",
            endDateFormItem: "",
            startTimeFormItem: "",
            endTimeFormItem: "",
            aFormItem: false,
            bFormItem: false,
            cFormItem: false,
            dFormItem: false,
            eFormItem: false,
            fFormItem: false,
            addSuccess: true
        })
        //localStorage.setItem("lastFetch", moment());
        setTimeout(() => {
            this.setState({
                addSuccess: false
                })
        }, 5000)
    }

    render() {
        return (
            <div>
                <h2>Athlete</h2><br />
                <Table striped key={this.state.sportData}>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Input type="select" name="sport" id="sport" value={this.state.sportFormItem} onChange={(e) => this.setState({sportFormItem: e.target.value}) }>
                                <option value="default" disabled>Sport</option>
                                {this.props.sportsList.map(item => (
                                    <option value={item.sportcode}>{item.sportname}</option>
                                    )) }
                            </Input>
                                <Button outline color="success" onClick={(e) => this.addSport(e)}>Add</Button>&nbsp;{this.state.addSuccess && <div>Success! <GoCheck /></div>}
                            </td>
                            <td><Input type="date" name="startdate" id="enddate" value={this.state.startDateFormItem} onChange={(e) => this.setState({startDateFormItem: e.target.value}) } />
                                Start Date</td>
                            <td><Input type="date" name="enddate" id="enddate" value={this.state.endDateFormItem} onChange={(e) => this.setState({ endDateFormItem: e.target.value })} />
                                End Date</td>
                            <td><Input type="time" name="starttime" id="starttime" value={this.state.startTimeFormItem} onChange={(e) => this.setState({ startTimeFormItem: e.target.value })} />
                                Start Time</td>
                            <td><Input type="time" name="endtime" id="endtime" value={this.state.endTimeFormItem} onChange={(e) => this.setState({ endTimeFormItem: e.target.value })} />
                                    End Time</td>
                            <td>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td><Input type="checkbox" name="checkA" id="checkA" checked={this.state.aFormItem} onClick={(e) => this.setState({aFormItem: e.target.checked})} /> L1</td>
                                            <td><Input type="checkbox" name="checkB" id="checkB" checked={this.state.bFormItem} onClick={(e) => this.setState({ bFormItem: e.target.checked })} /> L2</td>
                                            <td><Input type="checkbox" name="checkC" id="checkC" checked={this.state.eFormItem} onClick={(e) => this.setState({eFormItem: e.target.checked}) } /> Gym</td>
                                        </tr>
                                        <tr>
                                            <td><Input type="checkbox" name="checkD" id="checkD" checked={this.state.cFormItem} onClick={(e) => this.setState({cFormItem: e.target.checked}) } /> L3</td>
                                            <td><Input type="checkbox" name="checkE" id="checkE" checked={this.state.dFormItem} onClick={(e) => this.setState({dFormItem: e.target.checked}) } /> L4</td>
                                            <td><Input type="checkbox" name="checkF" id="checkF" checked={this.state.fFormItem} onClick={(e) => this.setState({fFormItem: e.target.checked }) } /> Volpe</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                        </tr>
                        {this.state.sportData.map(item => (
                            <tr>
                                <td>{item.sport}<br />
                                    <Button outline color="danger" onClick={(e) => this.deleteSport(item.pk) }>Delete</Button></td>
                                <td><Input type="date" name="startdate" id="startdate" defaultValue={item.startdate} onBlur={(e) => { if (e.target.value != item.startdate) this.updateSport("Start_Date", item.pk, e.target.value) }} />
                                    Start Date</td>
                                <td><Input type="date" name="enddate" id="enddate" defaultValue={item.enddate} onBlur={(e) => { if (e.target.value != item.enddate) this.updateSport("End_Date", item.pk, e.target.value) }} />
                                    End Date</td>
                                <td><Input type="time" name="starttime" id="starttime" defaultValue={item.starttime} onBlur={(e) => { if (e.target.value != item.starttime) this.updateSport("Start_Time", item.pk, e.target.value) }} />
                                    Start Time</td>
                                <td><Input type="time" name="endtime" id="endtime" defaultValue={item.endtime} onBlur={(e) => { if (e.target.value != item.endtime) this.updateSport("End_Time", item.pk, e.target.value) }} />
                                    End Time</td>
                                <td>
                                    <Table>
                                        <tbody>
                                            <tr>
                                                <td><Input type="checkbox" name="L1box" id="L1box" checked={item.l1_a} onClick={(e) => this.updateSport("L1", item.pk, e.target.checked)} />&nbsp;L1</td>
                                                <td><Input type="checkbox" name="L2box" id="L2box" checked={item.l2_b} onClick={(e) => this.updateSport("L2", item.pk, e.target.checked)} />&nbsp;L2</td>
                                                <td><Input type="checkbox" name="L3box" id="L3box" checked={item.gym_e} onClick={(e) => this.updateSport("Gym", item.pk, e.target.checked)} />&nbsp;Gym</td>
                                            </tr>
                                            <tr>
                                                <td><Input type="checkbox" name="L4box" id="L4box" checked={item.l3_c} onClick={(e) => this.updateSport("L3", item.pk, e.target.checked)} />&nbsp;L3</td>
                                                <td><Input type="checkbox" name="gymbox" id="gymbox" checked={item.l4_d} onClick={(e) => this.updateSport("L4", item.pk, e.target.checked)} />&nbsp;L4</td>
                                                <td><Input type="checkbox" name="volpebox" id="volpebox" checked={item.volpe_f} onClick={(e) => this.updateSport("Volpe", item.pk, e.target.checked)} />&nbsp;Volpe</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                            )) }
                    </tbody>
                </Table>
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(AthKeycardAthlete);